import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54a06b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Schrijf kort iets over iemand, een gebeurtenis of over iets dat jou verbindt met dit monument.", -1))
const _hoisted_2 = ["data-replica"]
const _hoisted_3 = ["maxlength", "tabindex"]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.newMelatiData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "grower",
          "data-replica": _ctx.newMelatiData.message
        }, [
          (_ctx.newMelatiData)
            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: 0,
                placeholder: "Begin met schrijven",
                maxlength: _ctx.msgMaxLength,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newMelatiData.message) = $event)),
                tabindex: _ctx.disable ? '-1' : '0',
                required: ""
              }, null, 8, _hoisted_3)), [
                [_vModelText, _ctx.newMelatiData.message]
              ])
            : _createCommentVNode("", true),
          (_ctx.msgError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.msgError), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}